import React from 'react';

import JsonDetails from '~/components/Common/Blocks/JsonDetails';

interface Props {
  paymentPlanComponent?: App.PaymentPlanComponent;
}

function PaymentPlanAdditionalInfo({ paymentPlanComponent }: Props) {
  if (!paymentPlanComponent) {
    return null;
  }

  return <JsonDetails title="Additional info" data={paymentPlanComponent.additional_info ?? {}} />;
}

export { PaymentPlanAdditionalInfo };
